import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import createSagaMiddleware from 'redux-saga'

import createHistory from 'history/createBrowserHistory'
import { routerMiddleware } from 'react-router-redux'

import reducer from 'reducers'
import saga from 'sagas'
import { checkAuthStatus } from 'actions'

export const history = createHistory()

const sagaMiddleware = createSagaMiddleware()

const store = createStore(
  reducer,
  composeWithDevTools(
    applyMiddleware(...[sagaMiddleware, routerMiddleware(history)])
  )
)

sagaMiddleware.run(saga)

store.dispatch(checkAuthStatus())

export default store



// WEBPACK FOOTER //
// ./src/store.js